import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';
import ListItemModel from 'src/model/listItem.model';

export interface IListsError {
  hasFailed: boolean;
  message: string;
}

export interface IListsSuccess {
  hasRemovedSucced: boolean;
  hasSucced: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_IS_PENDING_LISTS = false;
const INITIAL_IS_UPDATING = false;
const INITIAL_ERROR: IListsError = {
  hasFailed: false,
  message: ''
};
const INITIAL_SUCCESS: IListsSuccess = {
  hasRemovedSucced: false,
  hasSucced: false,
  message: ''
};

const lists = (
  state: IInitialState['lists']['lists'] = INITIAL_STATE.lists.lists || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_LISTS: {
      return payload;
    }
    default:
      return state;
  }
};

const currentList = (
  state: IInitialState['lists']['currentList'] = INITIAL_STATE.lists
    .currentList,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.CLEAR_CURRENT_LIST:
      return {};
    case types.SET_CURRENT_LIST_NUMBER: {
      return {
        ...state,
        listNumber: payload
      };
    }
    case types.SET_CURRENT_LIST_FAVORITE: {
      return {
        ...state,
        favorite: payload
      };
    }
    case types.SET_CURRENT_LIST_NAME: {
      return {
        ...state,
        name: payload
      };
    }
    case types.SET_ITEMS: {
      const items = payload as { [key: number]: ListItemModel };
      return {
        ...state,
        listItems: items
      };
    }
    case types.UPDATE_ITEM: {
      return {
        ...state,
        listItems: {
          ...state.listItems,
          [payload.listItemNumber]: {
            ...state.listItems[payload.listItemNumber],
            ...payload
          }
        }
      };
    }
    case types.REMOVE_ITEM: {
      const newState = state;
      delete newState.listItems[payload];
      return {
        ...newState
      };
    }
    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const isPendingLists = (
  state: boolean = INITIAL_IS_PENDING_LISTS,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING_LISTS:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const isUpdating = (
  state: boolean = INITIAL_IS_UPDATING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_UPDATING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: IListsError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const success = (
  state: IListsSuccess = INITIAL_SUCCESS,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_SUCCESS:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

export default combineReducers({
  lists,
  currentList,
  isPending,
  isPendingLists,
  isUpdating,
  error,
  success
});
